export enum StatusCodes {

    // 2XX

    SUCCESS_OK = 200,
    SUCCESS_CREATED = 201,
    SUCCESS_NO_CONTENT = 204,

    // 3XX

    REDIRECT_FOUND = 302,

    // 4XX
    BADREQUEST = 400,
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    CONFLICT = 409,

    // 5XX

    INTERNAL_SERVER_ERROR = 500,
    BAD_GATEWAY = 502,
    SERVICE_UNAVAILABLE = 503,
    GATEWAY_TIMEOUT = 504,
}
